import React from 'react'
import ReactDOM from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import amplifyOutputs from '../amplify_outputs.json'

Amplify.configure(amplifyOutputs)

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find root element')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)